module.exports = __webpack_public_path__ + "img/Case presentation Icon - white.2618fab9.svg";